import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
/**
 * Badges génériques + variantes "rarity" alignées sur le système d'achievements
 * (common / rare / epic / legendary). Les rarities ont un dégradé + une lueur.
 */
const badgeVariants = cva([
    'inline-flex items-center gap-1 rounded-full px-2.5 py-1',
    'font-display text-2xs font-semibold uppercase tracking-wider',
    'border',
], {
    variants: {
        variant: {
            default: 'bg-ink-800/80 text-ink-200 border-ink-700',
            electric: 'bg-electric-500/15 text-electric-300 border-electric-500/30',
            flame: 'bg-flame-500/15 text-flame-300 border-flame-500/30',
            royal: 'bg-royal-500/15 text-royal-300 border-royal-500/30',
            sunshine: 'bg-sunshine-400/15 text-sunshine-300 border-sunshine-400/30',
            success: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
            danger: 'bg-rose-500/15 text-rose-300 border-rose-500/30',
            // Rarities (achievements) — dégradé + animation subtile sur les rares
            common: 'bg-ink-800 text-ink-100 border-ink-600',
            rare: 'bg-electric-500/20 text-electric-200 border-electric-400/40 shadow-glow-electric',
            epic: 'bg-royal-500/25 text-royal-100 border-royal-400/50 shadow-glow-royal',
            legendary: 'bg-gradient-flame text-white border-flame-300/60 shadow-glow-flame animate-glow-pulse',
        },
        size: {
            sm: 'h-5 text-2xs',
            md: 'h-6 text-2xs',
            lg: 'h-7 text-xs',
        },
    },
    defaultVariants: { variant: 'default', size: 'md' },
});
export const Badge = forwardRef(function Badge({ className, variant, size, ...props }, ref) {
    return _jsx("span", { ref: ref, className: cn(badgeVariants({ variant, size }), className), ...props });
});
